"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var intl_format_1 = require("@biw/intl-format");
exports.formatNumber = intl_format_1.formatNumber;
var formatted_number_1 = tslib_1.__importDefault(require("./formatted-number"));
exports.FormattedNumber = formatted_number_1.default;
var locale_enhancer_1 = tslib_1.__importDefault(require("../locale-enhancer"));
exports.default = locale_enhancer_1.default(formatted_number_1.default);
//# sourceMappingURL=index.js.map